// ==============================|| OVERRIDES - INPUT BASE ||============================== //

export default function InputBase() {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.MuiOutlinedInput-root': {
            borderRadius: 8
          }
        },
        sizeSmall: {
          fontSize: '0.75rem'
        }
      }
    }
  };
}
